import React, { useState } from "react";
import _ from "lodash";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { triggerEditExampleReview, triggerSaveExampleReview } from "../../../../store/slices/reviews";
const TrainingExampleModal = ({
  selectedCompany,
  open,
  close,
  params,
  selectedReviewId,
  mode = "Add",
}) => {
  const dispatch = useDispatch();
  const [reviewText, setReviewText] = useState(
    params?.text ? params?.text : ""
  );
  const [responseText, setResponseText] = useState(
    params?.response ? params?.response : ""
  );
  const onClose = () => {
    close();
  };
  const onSave = () => {
    dispatch(
      triggerEditExampleReview({...params,
        companyId: selectedCompany,
        responseText: responseText,
        reviewId: '00000000-0000-0000-0000-000000000000',
        reviewText: reviewText,
      },selectedReviewId?selectedReviewId:null)
    );
    onClose();
  };
  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={onClose}>
      <DialogTitle>{mode} Training Example</DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={2}>
          <TextField
            label="Review Text"
            multiline
            rows={4}
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
          />
          <TextField
            label="Response Text"
            multiline
            rows={4}
            value={responseText}
            onChange={(e) => setResponseText(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: "start", my: 1, px: 3 }}>
        <Button
          variant="contained"
          disabled={_.size(reviewText) > 0 &&  _.size(responseText) > 0 ? false : true}
          onClick={onSave}
        >
          Save
        </Button>
        <Button variant="outlined" color="error" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrainingExampleModal;
